import { Button } from "@/components/ui/Button/Button";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/Empty/Empty";
import { CalendarSync } from "lucide-react";
import { Link } from "react-router-dom";

const EmptyRotations = () => {
  return (
    <Empty style={{ borderColor: "var(--secondary-border)" }}>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <CalendarSync />
        </EmptyMedia>
        <EmptyTitle>No Rotations Found</EmptyTitle>
        <EmptyDescription>
          There were no rotations found. If you believe this is an error, please
          refresh.
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button asChild>
          <Link to="/rotations" style={{ textDecoration: "none" }}>
            <CalendarSync />
            Go To Rotations
          </Link>
        </Button>
      </EmptyContent>
    </Empty>
  );
};

export { EmptyRotations };
